module.exports = __webpack_public_path__ + "d20d04b4d92ec98f800eb08775af5512.pdf";